<template>
    <div class="vx-card">

      <div class="vx-card__body card-body">

        <div class="vx-row">
          <modify-popup
            :show="ModifyPopup"
            :model="modalModel"
            :accounts="allAccounts"
            @finish="onfinish"
            @close="closeModifyPopup"
          >
          </modify-popup>
          <div class="vx-col w-full mb-base">

            <data-grid
              ref="grid"
              stripe
              :data-source="gridDataSource"
              :columns="[
                { title: $t('Name'), sort: 'Name' },
                { title: $t('Lastname'), sort: 'Lastname' },
                { title: $t('SocialSecurityNumber'), sort: 'SocialSecurityNumber' },
                { title: $t('CreationDate'), sort: 'CreationDate' },
                { title: $t('Action'), sort: 'Action' },
              ]"
            >
              <template slot-scope="{ row }">
                <td>
                  {{ row.name }}
                </td>
                <td>
                  {{ row.family }}
                </td>
                <td style="direction: ltr">
                  {{ row.nationalCode }}
                </td>
                <td style="direction: ltr">
                  {{ row.createOn }}
                </td>
                <td style="direction: ltr">
                  <vs-button
                    color="primary"
                    type="border"
                    icon-pack="feather"
                    icon="icon-eye"
                    class="view-btn"
                    v-has-permission="permission235"
                    @click="createAccount(row)"
                    >{{ $t("Accounts") }}</vs-button
                  >
                </td>
              </template>
            </data-grid>
          </div>
        </div>
      </div>
    </div>

</template>

<script>
import { mapActions, mapGetters } from "vuex";

  import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
  import DataGrid from "@/components/datagrid/DataGrid";
  import ModifyPopup from "./CreatePettyCashAccount.vue";

  export default {
    components: {
      ModifyPopup,
      DataGrid,

    },
    data() {
      return {
        permission235:"AssignAccounts|GetAllAccounts",
        ModifyPopup: false,
        itemList: [],
        allAccounts: [],
        modalModel: {},
        parentType: 0,
        gridDataSource: {
          type: "app",
          service: "/Credits/api/PettyCashesQuery/by-paging",
        },

      };
    },
    mounted(){
      this.getAccount()
    },
    methods: {
      ...mapActions({
      fetchPettyCashAccount: "pettyCash/fetchAllLastAccount",
    }),
    getAccount() {
        this.fetchPettyCashAccount().then((result) => {
        this.allAccounts = result;
      });

    },
      showAccounts(){
        this.$router.push({ path: '/PettyCash/Accounts' });
      },
      createAccount(accountsInfo) {
        this.ModifyPopup = true;
        this.modalModel = accountsInfo;
        this.ModifyPopupflag = true;
      },
      closeModifyPopup() {
        this.ModifyPopup = false;
      },
      onfinish() {
        this.closeModifyPopup();
        this.$refs.grid.renderGrid();
      },
     
    },
  }
  </script>

<style scoped></style>
